import { apiMipe } from '@/core/api/';

export const getValidationMessages = async (messageCodes) => {
  try {
    const qs = messageCodes.join('&messageCodes=');
    const { data } = await apiMipe.get(
      `/api/validationsMessages?messageCodes=${qs}`
    );
    return data;
  } catch (error) {
    return [];
  }
};
